import { getTestCountsByFocusArea } from 'libs/end-to-end/src/tests-utils';
import { MyFocusAreaDefinition } from 'libs/end-to-end/src/my-focus-area-definition';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { getCalibrationScore } from 'libs/end-to-end/src/tests-utils';
import React from 'react';
import { OptimizationSection } from 'apps/sigma2-ui/src/disparityAndOptimization/components/OptimizationSection';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const FocusAreaSummaryDescription = ({
  focusAreaDefinition,
  metric,
  myObservation,
  calibrationFraming,
}: {
  focusAreaDefinition: MyFocusAreaDefinition;
  metric: string;
  myObservation: MyObservation | null;
  calibrationFraming: CalibrationFraming;
}) => {
  const navigate = useNavigateSafe();
  const language = useLanguage();

  if (!myObservation || !myObservation.testSummary) {
    return <></>;
  }

  const calibrationScore = getCalibrationScore({
    testCount: getTestCountsByFocusArea(
      myObservation.testSummary.tests,
      focusAreaDefinition.focusArea,
    ),
  });

  return (
    <div
      className={
        'min-h-full w-full h-full bg-white px-10 py-14 rounded-tl-lg rounded-bl-lg'
      }
    >
      <OptimizationSection
        focusAreaDefinition={focusAreaDefinition}
        metric={metric}
        calibrationScore={calibrationScore}
        testSummary={myObservation.testSummary}
        leftFooter={
          <button
            onClick={() => {
              navigate(`/${focusAreaDefinition.focusArea}/summary-v2`);
            }}
          >
            <S2Typography
              variant="link"
              translatedContent={language.exploreCalibrationLevels({
                calibrationFraming,
              })}
            />
          </button>
        }
        tooltipMode="dimension"
        calibrationFraming={myObservation.calibrationFraming}
      />
    </div>
  );
};
